import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import {
  PATIENT_DOCUMENTS_CONTROLER_URL,
  PATIENT_DOCUMENTS_UPLOAD,
} from "api/Service";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

const useUploadDocument = ({ onSuccess } = {}) => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error while saving document");

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({ imageFile, formData, patient }) => {
      const axiosInstance = createAxiosInstance();
      let documentId;
      let documentUrl;

      if (imageFile && formData.documentType) {
        const data = new FormData();
        data.append("file", imageFile);
        data.append("name", formData.name);

        const patientId = patient?.patient_id || formData.patientId;
        const uploadResponse = await axiosInstance.post(
          `${tenantVal}${PATIENT_DOCUMENTS_UPLOAD}/${formData.documentType}/patient/${patientId}`,
          data
        );

        documentId = uploadResponse.data?.id;
        documentUrl = uploadResponse.data?.documentUrl;
      }

      const postData = {
        id: documentId,
        tenant: tenantVal,
        patientId: patient?.patient_id || formData.patientId,
        patient: {
          id: patient?.patient_id || formData.patientId,
          tenant: tenantVal,
          doctorDetailsId: formData.staffMemberId,
          doctorDetails: {
            id: formData.staffMemberId,
            tenant: tenantVal,
          },
        },
        reviewerStaffId: formData.staffMemberId,
        documentTypeId: formData.documentType,
        documentTypes: {
          id: formData.documentType,
          tenant: tenantVal,
        },
        status: formData.status,
        priority: formData.priority,
        name: formData.name,
        documentUrl: documentUrl,
      };

      const response = await axiosInstance.post(
        `${tenantVal}${PATIENT_DOCUMENTS_CONTROLER_URL}`,
        postData
      );

      return { response, isUpdate: !!formData.id };
    },
    onSuccess: ({ isUpdate }) => {
      toast.success(
        `Document ${isUpdate ? "updated" : "saved"} successfully`
      );
      queryClient.invalidateQueries({ queryKey: ["patientDocuments"] });
      onSuccess?.();
    },
    onError: handleNetworkError,
  });
};

export { useUploadDocument };

